/**
 * PJ Live Search — ricerca fullscreen con filtri live (stile Doofinder)
 * Catalogo + metafield componenti caricato dal feed /collections/all?view=pjls-data
 * (250? no: 50/pagina), tutto client-side. Filtri allineati alle categorie:
 * Categoria (tag), Scheda video, Processore, Scheda madre, RAM, Archiviazione, Prezzo.
 *
 * Restyling 2026 (10/10/2026): stessa logica (filtri, esclusioni, ordinamenti, vista iniziale),
 * aspetto nuovo. Le card arrivano GIÀ PRONTE dal feed (campo "card" = snippet product-card),
 * quindi sono identiche a quelle di categorie e pagina di ricerca. Filtri a fisarmonica con le
 * stesse caselle delle categorie; da mobile i filtri si aprono a pannello con il bottone
 * "Mostra N risultati". A ricerca vuota compaiono le ricerche più frequenti.
 */
(function () {
  'use strict';
  var HIDDEN_TAGS = ['solo-configuratore', 'globo-product-options', 'addon', 'commissione', 'no-ricerca'];
  /* Prodotti da NON mostrare nella ricerca, per handle: sono servizi, non prodotti da catalogo.
     In alternativa basta assegnare al prodotto il tag "no-ricerca" (già in HIDDEN_TAGS).
     31/08: svuotato — Roberto vuole che TUTTI e quattro gli FPS Boost escano dalla ricerca,
     quindi 'fps-boost' non e' piu' escluso (era stato tolto l'8/08). */
  var HIDDEN_HANDLES = [];
  /* ── Eccezioni: prodotti che devono uscire nella ricerca ANCHE se hanno un tag di HIDDEN_TAGS.
     Servono per le due copie "addon" degli FPS Boost, che sono taggate addon/solo-configuratore
     perche' alimentano il box "Potenzia il tuo PC", ma che Roberto vuole comunque cercabili.
     Per aggiungerne altri in futuro NON serve toccare il codice: basta assegnare al prodotto il
     tag "sempre-in-ricerca" dall'admin Shopify. */
  var ALWAYS_VISIBLE_TAGS = ['sempre-in-ricerca'];
  var ALWAYS_VISIBLE_HANDLES = [
    'upgrade-ssd-2tb-nvme-copia',                  /* FPS Boost (Maggiori Prestazioni) */
    'fps-boost-servizio-di-ottimizzazione-copia'   /* FPS Boost + (Massime Prestazioni + Dual Boot) */
  ];
  /* Vista iniziale (prima che l'utente scriva qualcosa): si mostrano SOLO i PC, cioè i prodotti
     col tag "Gaming" — è quello che hanno GLADIO, EGEMONE e TITANO, mentre monitor e periferiche
     usano altri tag ("PERIFERICHE", "TASTIERE DA GAMING") e quindi restano fuori.
     Confronto esatto e minuscolo/maiuscolo insensibile: "TASTIERE DA GAMING" NON deve passare.
     Appena si digita una parola o si applica un filtro, la ricerca torna su tutto il catalogo. */
  var DEFAULT_TAGS = ['gaming'];
  var EXCLUDED_TAG_FACETS = ['solo-configuratore', 'commissione', 'new', 'addon', 'preventivi personalizzati'];
  /* Ricerche suggerite a campo vuoto: un clic le scrive nel campo. */
  var POPULAR = ['RTX 5070 Ti', 'RTX 5080', 'RX 9070 XT', '9800X3D', 'White', 'Monitor'];
  var OPEN_BY_DEFAULT = { cat: true, gpu: true, cpu: true };

  /* Definizione facet. cat = dai tag (multi-valore); gli altri = campo metafield singolo. */
  var FACET_DEFS = [
    { key: 'cat',      label: 'Categoria',              source: 'tags', nice: true },
    { key: 'gpu',      label: 'Scheda video',           source: 'gpu' },
    { key: 'cpu',      label: 'Processore',             source: 'cpu' },
    { key: 'mobo',     label: 'Scheda madre',           source: 'mobo' },
    { key: 'ram',      label: 'Memoria RAM',            source: 'ram' },
    { key: 'storage',  label: 'Archiviazione',          source: 'storage' },
    { key: 'storage2', label: 'Archiviazione secondaria', source: 'storage2' },
    { key: 'monitor',  label: 'Monitor',                source: 'monitor' },
    { key: 'kit',      label: 'Kit tastiera / mouse',   source: 'kit' },
    { key: 'casse',    label: 'Casse',                  source: 'casse' }
  ];

  var state = {
    loaded: false, loading: false, products: [],
    q: '', sel: {}, expanded: {}, openGroups: {}, priceMin: null, priceMax: null,
    sort: 'newest'   /* a ricerca vuota si parte dagli ULTIMI ARRIVI, non dall'ordine della collezione */
  };
  FACET_DEFS.forEach(function (d) { state.sel[d.key] = {}; state.expanded[d.key] = false; });

  var overlay = null, els = {};

  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(n) {
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n); }
    catch (e) { return '€ ' + n.toFixed(2).replace('.', ','); }
  }
  var ICON_SEARCH = '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7.5"/><path d="M20.5 20.5 16.4 16.4"/></svg>';
  var ICON_X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_FILTER = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12"/><circle cx="16" cy="6" r="2"/><circle cx="10" cy="12" r="2"/><circle cx="18" cy="18" r="2"/></svg>';
  var ICON_SORT = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M7 4v16M3 8l4-4 4 4M17 20V4M13 16l4 4 4-4"/></svg>';
  function nice(tag) { return tag.charAt(0).toUpperCase() + tag.slice(1).toLowerCase(); }

  /* ── Costruzione overlay ── */
  function build() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'pjls-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Cerca nel negozio');
    overlay.innerHTML =
      '<div class="pjls-head"><div class="pjls-head__in">' +
      '  <a href="/" class="pjls-head__logo" aria-label="Home">' + (window.pjlsLogo ? '<img src="' + esc(window.pjlsLogo) + '" alt="PJ Digital Store">' : '') + '</a>' +
      '  <div class="pjls-field">' + ICON_SEARCH +
      '    <input type="search" class="pjls-input" placeholder="Cerca PC, schede video, processori, monitor…" autocomplete="off" enterkeyhint="search" aria-label="Cerca">' +
      '    <button class="pjls-clear" type="button" aria-label="Svuota la ricerca" hidden>' + ICON_X + '</button>' +
      '    <kbd class="pjls-kbd">Esc</kbd>' +
      '  </div>' +
      '  <button class="pjls-close" type="button" aria-label="Chiudi la ricerca">' + ICON_X + '</button>' +
      '</div>' +
      '<div class="pjls-popular"><div class="pjls-popular__in"><span class="pjls-popular__lbl">Ricerche frequenti</span>' +
      POPULAR.map(function (t) { return '<button type="button" class="pjls-pop" data-q="' + esc(t) + '">' + esc(t) + '</button>'; }).join('') +
      '</div></div></div>' +
      '<div class="pjls-body">' +
      '  <aside class="pjls-filters" aria-label="Filtri"></aside>' +
      '  <div class="pjls-main">' +
      '    <div class="pjls-toolbar">' +
      '      <button class="pjls-filters-toggle" type="button">' + ICON_FILTER + '<span>Filtri</span><em class="pjls-ftcount" hidden></em></button>' +
      '      <p class="pjls-count" aria-live="polite"></p>' +
      '      <label class="pjls-sortbox">' + ICON_SORT + '<span>Ordina per</span>' +
      '        <select class="pjls-sort" aria-label="Ordina">' +
      '          <option value="newest">Ultimi arrivi</option>' +
      '          <option value="relevance">Rilevanza</option>' +
      '          <option value="price_asc">Prezzo: dal più basso</option>' +
      '          <option value="price_desc">Prezzo: dal più alto</option>' +
      '          <option value="title">Nome A-Z</option>' +
      '        </select></label>' +
      '    </div>' +
      '    <div class="pjls-chips"></div>' +
      '    <div class="pjls-grid"></div>' +
      '    <div class="pjls-loading" style="display:none;"><span class="pjls-spin" aria-hidden="true"></span>Carico il catalogo…</div>' +
      '    <div class="pjls-empty" style="display:none;"></div>' +
      '  </div>' +
      '</div>';
    document.body.appendChild(overlay);
    els = {
      input: overlay.querySelector('.pjls-input'),
      clear: overlay.querySelector('.pjls-clear'),
      close: overlay.querySelector('.pjls-close'),
      filters: overlay.querySelector('.pjls-filters'),
      ftoggle: overlay.querySelector('.pjls-filters-toggle'),
      chips: overlay.querySelector('.pjls-chips'),
      count: overlay.querySelector('.pjls-count'),
      sort: overlay.querySelector('.pjls-sort'),
      grid: overlay.querySelector('.pjls-grid'),
      loading: overlay.querySelector('.pjls-loading'),
      empty: overlay.querySelector('.pjls-empty'),
      ftcount: overlay.querySelector('.pjls-ftcount'),
      main: overlay.querySelector('.pjls-main')
    };
    function syncQuery() {
      state.q = els.input.value;
      els.clear.hidden = !els.input.value;
      overlay.classList.toggle('has-query', !!els.input.value);
      render();
    }
    els.input.addEventListener('input', syncQuery);
    els.clear.addEventListener('click', function () { els.input.value = ''; syncQuery(); els.input.focus(); });
    els.close.addEventListener('click', close);
    els.sort.addEventListener('change', function () { state.sort = els.sort.value; render(); });
    els.ftoggle.addEventListener('click', function () { setFiltersOpen(!els.filters.classList.contains('is-open')); });
    overlay.querySelectorAll('.pjls-pop').forEach(function (b) {
      b.addEventListener('click', function () { els.input.value = b.dataset.q; syncQuery(); els.input.focus(); });
    });
    /* Esc: prima chiude il pannello filtri (mobile), poi la ricerca */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !overlay.classList.contains('is-open')) return;
      if (els.filters.classList.contains('is-open')) { setFiltersOpen(false); return; }
      close();
    });
  }

  /* ── Caricamento catalogo (feed con metafield) ── */
  function loadCatalog() {
    if (state.loaded || state.loading) return;
    state.loading = true;
    els.loading.style.display = 'block';
    var all = [];
    function page(n) {
      fetch('/collections/all?view=pjls-data&page=' + n)
        .then(function (r) { return r.text(); })
        .then(function (txt) {
          var items = [];
          try { items = JSON.parse(txt) || []; } catch (e) { items = []; }
          all = all.concat(items);
          if (items.length === 50 && n < 12) { page(n + 1); }
          else { finish(all); }
        })
        .catch(function () { finish(all); });
    }
    function finish(items) {
      state.products = items.map(function (p) {
        var tags = (p.tags || []).map(function (t) { return String(t).trim(); });
        var price = parseFloat(p.price) || 0;
        var compare = parseFloat(p.compare) || 0;
        var specs0 = [p.gpu, p.cpu, p.mobo, p.ram, p.storage, p.storage2, p.monitor, p.kit, p.casse].filter(Boolean).join(' ');
        return {
          title: p.title, url: p.url, vendor: p.vendor || '',
          /* handle e created arrivano dal feed: il primo serve a escludere prodotti specifici
             (FPS Boost), il secondo a ordinare per ultimi arrivi. ⚠️ Se non li si copia qui,
             filtro e ordinamento restano silenziosamente senza effetto. */
          handle: p.handle || '',
          created: parseInt(p.created, 10) || 0,
          tags: tags, price: price, compare: compare,
          available: p.available !== false,
          gpu: p.gpu || '', cpu: p.cpu || '', mobo: p.mobo || '', ram: p.ram || '', storage: p.storage || '', storage2: p.storage2 || '', monitor: p.monitor || '', kit: p.kit || '', casse: p.casse || '',
          img: p.image || '',
          card: p.card || '',
          hay: (p.title + ' ' + (p.vendor || '') + ' ' + tags.join(' ') + ' ' + specs0).toLowerCase()
        };
      }).filter(function (p) {
        /* whitelist: valutata PRIMA delle esclusioni, ma dopo i controlli non negoziabili
           (prodotti opzione di Globo e non disponibili restano comunque fuori) */
        var handle = String(p.handle || '').toLowerCase();
        var forced = ALWAYS_VISIBLE_HANDLES.indexOf(handle) !== -1 ||
                     p.tags.some(function (t) { return ALWAYS_VISIBLE_TAGS.indexOf(t.toLowerCase()) !== -1; });
        if (!forced) {
          if (handle && HIDDEN_HANDLES.indexOf(handle) !== -1) return false;
          if (p.tags.some(function (t) { return HIDDEN_TAGS.indexOf(t.toLowerCase()) !== -1; })) return false;
        }
        if (/option-set|image-swatches/i.test(p.url || '')) return false; /* prodotti opzione/addon usati da Globo */
        if (!p.available) return false; /* nascondi prodotti non disponibili dalla ricerca */
        return true;
      });
      state.loaded = true; state.loading = false;
      els.loading.style.display = 'none';
      renderFilters();
      render();
    }
    page(1);
  }

  /* ── Conteggi facet ── */
  function isBadCat(tl) {
    if (tl.indexOf('fps-') === 0) return true;
    if (tl.indexOf('option-set') !== -1 || tl.indexOf('option_set') !== -1 || tl.indexOf('optionset') !== -1 || tl.indexOf('globo') !== -1) return true;
    if (EXCLUDED_TAG_FACETS.indexOf(tl) !== -1) return true;
    return false;
  }
  function facetCounts(list, def) {
    var counts = {};
    list.forEach(function (p) {
      if (def.source === 'tags') {
        p.tags.forEach(function (t) {
          if (isBadCat(t.toLowerCase())) return;
          counts[t] = (counts[t] || 0) + 1;
        });
      } else {
        var v = p[def.source];
        if (v) counts[v] = (counts[v] || 0) + 1;
      }
    });
    return Object.keys(counts).map(function (k) { return [k, counts[k]]; })
      .sort(function (a, b) { return b[1] - a[1]; });
  }

  function facetHtml(entries, def) {
    var expanded = state.expanded[def.key];
    var selected = state.sel[def.key];
    var limit = expanded ? entries.length : 6;
    var nSel = Object.keys(selected).length;
    var open = OPEN_BY_DEFAULT[def.key] || nSel > 0 || state.openGroups[def.key];
    var html = '<details class="pjls-group" data-group="' + def.key + '"' + (open ? ' open' : '') + '>' +
      '<summary><span>' + esc(def.label) + '</span>' + (nSel ? '<em>' + nSel + '</em>' : '') + '</summary><div class="pjls-group__body">';
    entries.slice(0, limit).forEach(function (e) {
      var lbl = def.nice ? nice(e[0]) : e[0];
      html += '<label class="pjls-check"><input type="checkbox" data-facet="' + def.key + '" value="' + esc(e[0]) + '"' +
        (selected[e[0]] ? ' checked' : '') + '><span class="pjls-check__box" aria-hidden="true"></span><span class="pjls-check__lbl">' + esc(lbl) + '</span>' +
        '<span class="pjls-check__count">' + e[1] + '</span></label>';
    });
    if (entries.length > 6) {
      html += '<button class="pjls-more" type="button" data-facet="' + def.key + '">' +
        (expanded ? 'Mostra meno' : 'Mostra altri ' + (entries.length - 6)) + '</button>';
    }
    return html + '</div></details>';
  }

  function setFiltersOpen(on) {
    els.filters.classList.toggle('is-open', on);
    overlay.classList.toggle('filters-open', on);
  }

  function renderFilters() {
    var active = chipsAttive();
    var html = '<div class="pjls-filters__head"><p class="pjls-filters__heading">' + ICON_FILTER + 'Filtri</p>' +
      (active ? '<button type="button" class="pjls-reset">Azzera</button>' : '') +
      '<button type="button" class="pjls-filters__x" aria-label="Chiudi i filtri">' + ICON_X + '</button></div>' +
      '<div class="pjls-filters__scroll">';
    FACET_DEFS.forEach(function (def) {
      var entries = facetCounts(state.products, def);
      if (!entries.length) return;
      html += facetHtml(entries, def);
    });
    var pOpen = state.priceMin != null || state.priceMax != null || state.openGroups.price;
    html += '<details class="pjls-group" data-group="price"' + (pOpen ? ' open' : '') + '><summary><span>Prezzo</span></summary><div class="pjls-group__body">' +
      '<div class="pjls-price">' +
      '<label class="pjls-price__f"><span>€</span><input type="number" min="0" inputmode="numeric" class="pjls-pmin" placeholder="Min" aria-label="Prezzo minimo"></label>' +
      '<span class="pjls-price__sep">–</span>' +
      '<label class="pjls-price__f"><span>€</span><input type="number" min="0" inputmode="numeric" class="pjls-pmax" placeholder="Max" aria-label="Prezzo massimo"></label></div></div></details>';
    html += '</div><div class="pjls-filters__foot"><button type="button" class="pjls-apply">Mostra i risultati</button></div>';
    els.filters.innerHTML = html;

    els.filters.querySelectorAll('details.pjls-group').forEach(function (d) {
      d.addEventListener('toggle', function () { state.openGroups[d.dataset.group] = d.open; });
    });
    var reset = els.filters.querySelector('.pjls-reset');
    if (reset) reset.addEventListener('click', function () {
      FACET_DEFS.forEach(function (def) { state.sel[def.key] = {}; });
      state.priceMin = null; state.priceMax = null;
      renderFilters(); render();
    });
    els.filters.querySelector('.pjls-filters__x').addEventListener('click', function () { setFiltersOpen(false); });
    els.filters.querySelector('.pjls-apply').addEventListener('click', function () { setFiltersOpen(false); els.main && (els.main.scrollTop = 0); });

    els.filters.querySelectorAll('input[type="checkbox"]').forEach(function (cb) {
      cb.addEventListener('change', function () {
        var store = state.sel[cb.dataset.facet];
        if (!store) return;
        if (cb.checked) store[cb.value] = true; else delete store[cb.value];
        var scroll = els.filters.querySelector('.pjls-filters__scroll');
        var top = scroll ? scroll.scrollTop : 0;
        renderFilters(); render();
        var scroll2 = els.filters.querySelector('.pjls-filters__scroll');
        if (scroll2) scroll2.scrollTop = top;
        /* dopo il ridisegno si rimette il focus sulla stessa casella (tastiera) */
        var facet = cb.dataset.facet, val = cb.value;
        els.filters.querySelectorAll('input[type="checkbox"]').forEach(function (x) {
          if (x.dataset.facet === facet && x.value === val) x.focus({ preventScroll: true });
        });
      });
    });
    var pmin = els.filters.querySelector('.pjls-pmin');
    var pmax = els.filters.querySelector('.pjls-pmax');
    if (pmin) pmin.value = state.priceMin != null ? state.priceMin : '';
    if (pmax) pmax.value = state.priceMax != null ? state.priceMax : '';
    [pmin, pmax].forEach(function (inp) {
      if (!inp) return;
      inp.addEventListener('input', function () {
        state.priceMin = pmin.value === '' ? null : parseFloat(pmin.value);
        state.priceMax = pmax.value === '' ? null : parseFloat(pmax.value);
        render();
      });
    });
    els.filters.querySelectorAll('.pjls-more').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var k = btn.dataset.facet;
        state.expanded[k] = !state.expanded[k];
        state.openGroups[k] = true;
        renderFilters();
      });
    });
  }

  /* ── Risultati ── */
  function filtered() {
    var tokens = state.q.toLowerCase().split(/\s+/).filter(Boolean);
    return state.products.filter(function (p) {
      if (tokens.length && !tokens.every(function (t) { return p.hay.indexOf(t) !== -1; })) return false;
      for (var i = 0; i < FACET_DEFS.length; i++) {
        var def = FACET_DEFS[i];
        var keys = Object.keys(state.sel[def.key]);
        if (!keys.length) continue;
        if (def.source === 'tags') {
          if (!keys.some(function (c) { return p.tags.indexOf(c) !== -1; })) return false;
        } else {
          if (keys.indexOf(p[def.source]) === -1) return false;
        }
      }
      if (state.priceMin != null && p.price < state.priceMin) return false;
      if (state.priceMax != null && p.price > state.priceMax) return false;
      return true;
    });
  }

  /* true se l'utente ha applicato almeno un filtro o un intervallo di prezzo */
  function chipsAttive() {
    if (state.priceMin != null || state.priceMax != null) return true;
    for (var i = 0; i < FACET_DEFS.length; i++) {
      if (Object.keys(state.sel[FACET_DEFS[i].key]).length) return true;
    }
    return false;
  }

  function render() {
    if (!state.loaded) return;
    var list = filtered();
    /* "newest" ordina per data di creazione (campo created del feed); i prodotti senza data
       restano in coda invece di finire in cima con valore 0. */
    if (state.sort === 'newest') list.sort(function (a, b) { return (b.created || 0) - (a.created || 0); });
    else if (state.sort === 'price_asc') list.sort(function (a, b) { return a.price - b.price; });
    else if (state.sort === 'price_desc') list.sort(function (a, b) { return b.price - a.price; });
    else if (state.sort === 'title') list.sort(function (a, b) { return a.title.localeCompare(b.title); });
    /* Vista iniziale: solo i PC. Se il tag non trovasse nulla (rinominato, rimosso...) si
       ripiega sull'intero catalogo: meglio mostrare tutto che una ricerca vuota. */
    var senzaRicerca = !state.q && !chipsAttive();
    var soloPc = false;
    if (senzaRicerca) {
      var pc = list.filter(function (p) {
        return p.tags.some(function (t) { return DEFAULT_TAGS.indexOf(String(t).trim().toLowerCase()) !== -1; });
      });
      if (pc.length) { list = pc; soloPc = true; }
    }
    els.count.innerHTML = (soloPc ? '<span class="pjls-count__lbl">' + (state.sort === 'newest' ? 'Ultimi PC arrivati' : 'I nostri PC') + '</span>' : '') +
      '<strong>' + list.length + '</strong> ' + (list.length === 1 ? 'risultato' : 'risultati') +
      (state.q ? ' per <q>' + esc(state.q) + '</q>' : '');
    var nAct = 0;
    FACET_DEFS.forEach(function (d) { nAct += Object.keys(state.sel[d.key]).length; });
    if (state.priceMin != null || state.priceMax != null) nAct++;
    els.ftcount.hidden = !nAct; els.ftcount.textContent = nAct;
    var apply = els.filters.querySelector('.pjls-apply');
    if (apply) apply.textContent = list.length ? 'Mostra ' + list.length + (list.length === 1 ? ' risultato' : ' risultati') : 'Nessun risultato';
    renderChips();
    if (!list.length) {
      els.grid.innerHTML = '';
      els.empty.innerHTML = '<strong>Nessun prodotto trovato' + (state.q ? ' per “' + esc(state.q) + '”' : '') + '</strong>' +
        '<span>Prova con meno parole o togli qualche filtro. Cerchi una configurazione su misura? ' +
        '<a href="/pages/configuratore">Usa il configuratore</a>.</span>';
      els.empty.style.display = 'block';
      return;
    }
    els.empty.style.display = 'none';
    /* Card 2026 già pronta dal feed (snippet product-card); se manca, card semplice nello stesso stile */
    els.grid.innerHTML = list.slice(0, 60).map(function (p) {
      if (p.card) return p.card;
      var onSale = p.compare > p.price;
      var src = p.img;
      if (src && src.indexOf('//') === 0) src = 'https:' + src;
      return '<article class="pjc"><a href="' + esc(p.url) + '" class="pjc__media" tabindex="-1" aria-hidden="true">' +
        (src ? '<img class="pjc__img" src="' + esc(src) + '" alt="" loading="lazy">' : '<span class="pjc__img pjc__img--ph"></span>') +
        (onSale ? '<span class="pjc__badges"><span class="pjc__badge pjc__badge--sale">-' + money(p.compare - p.price) + '</span></span>' : '') +
        '</a><div class="pjc__body"><div class="pjc__head"><h3 class="pjc__title pjc__title--long"><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3></div>' +
        '<div class="pjc__price"><div class="pjc__price-row"><span class="pjc__now">' + money(p.price) + '</span>' +
        (onSale ? '<s class="pjc__was">' + money(p.compare) + '</s>' : '') + '</div></div></div></article>';
    }).join('');
    if (list.length > 60) {
      els.grid.insertAdjacentHTML('beforeend', '<p class="pjls-more-results">Vedi i primi 60 di ' + list.length + '. ' +
        (state.q ? '<a href="/search?q=' + encodeURIComponent(state.q) + '&type=product">Vedi tutti i risultati</a>' : 'Usa i filtri o scrivi cosa cerchi per restringere.') + '</p>');
    }
  }

  function renderChips() {
    var chips = [];
    if (state.priceMin != null || state.priceMax != null) {
      chips.push({ label: money(state.priceMin || 0) + ' - ' + (state.priceMax != null ? money(state.priceMax) : '∞'), type: 'price' });
    }
    FACET_DEFS.forEach(function (def) {
      Object.keys(state.sel[def.key]).forEach(function (v) {
        chips.push({ label: def.nice ? nice(v) : v, facet: def.key, value: v });
      });
    });
    els.chips.innerHTML = chips.map(function (ch, i) {
      return '<button class="pjls-chip" data-i="' + i + '" type="button" aria-label="Togli il filtro ' + esc(ch.label) + '">' + esc(ch.label) + ICON_X + '</button>';
    }).join('') + (chips.length ? '<button class="pjls-chip pjls-chip--all" data-i="all" type="button">Azzera i filtri</button>' : '');
    els.chips.hidden = !chips.length;
    els.chips.querySelectorAll('.pjls-chip').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.dataset.i;
        if (i === 'all') {
          FACET_DEFS.forEach(function (def) { state.sel[def.key] = {}; });
          state.priceMin = null; state.priceMax = null;
        } else {
          var ch = chips[parseInt(i, 10)];
          if (ch.type === 'price') { state.priceMin = null; state.priceMax = null; }
          else delete state.sel[ch.facet][ch.value];
        }
        renderFilters(); render();
      });
    });
  }

  /* ── Apertura/chiusura ── */
  function open() {
    build();
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { els.input.focus(); }, 30);
    loadCatalog();
    if (state.loaded) render();
  }
  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    setFiltersOpen(false);
    document.body.style.overflow = '';
  }

  window.PJLiveSearch = { open: open, close: close };

  function bind() {
    document.querySelectorAll('.js-search-toggle').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
